import React from "react";
// Sections
import Header from "../components/Sections/Header";
import Contact from "../components/Sections/Contact";
import HowItWorks from "../components/Sections/HowItWorks";
import SprinkleEffect from "../components/Elements/Sprinkle";
import ServicesSection from "../components/Sections/LandServices";
import { Helmet } from "react-helmet";

export default function Landing() {
  return (
    <>
      <Helmet>
        <title>Home | Pak Maid Service</title>
        <meta
          name="description"
          content="Welcome to Pak Maid Service. Get professional home cleaning and maid services in Pakistan."
        />
      </Helmet>
      <SprinkleEffect />
      <Header />
      <ServicesSection />
      <HowItWorks />
      <Contact />
    </>
  );
}
